module.exports = __webpack_public_path__ + "70fc55d854d764bd9036a7f163c8cb8e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Sheep2.jpeg
// module id = 3483
// module chunks = 0